import React from "react";
import { Link } from "react-router-dom";
import { GitCompareArrows, X } from "lucide-react";
import { useCompare } from "@/context/CompareContext";

export default function CompareDrawer() {
  const { items, remove, clear } = useCompare();
  if (items.length === 0) return null;

  return (
    <div
      data-testid="compare-drawer"
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 backdrop-blur-xl bg-white/90 border border-amber-200 px-6 py-4 flex items-center gap-4 shadow-2xl"
    >
      <GitCompareArrows className="w-4 h-4 text-[#D4A437]" strokeWidth={1.5} />
      <span className="text-xs tracking-[0.2em] uppercase text-slate-700">Compare</span>
      <div className="flex items-center gap-2">
        {items.map((p) => (
          <div key={p.id} className="flex items-center gap-2 px-3 py-1.5 border border-slate-200 text-xs text-slate-700">
            <span className="max-w-[120px] truncate">{p.name}</span>
            <button onClick={() => remove(p.id)} data-testid={`compare-remove-${p.id}`}>
              <X className="w-3 h-3 text-slate-500 hover:text-[#D4A437]" />
            </button>
          </div>
        ))}
        {items.length < 3 && (
          <span className="text-[10px] text-slate-500">Add {3 - items.length} more</span>
        )}
      </div>
      <Link
        to="/compare"
        data-testid="compare-go-btn"
        className="ml-2 px-5 py-2 bg-[#D4A437] text-white text-xs font-medium tracking-wide hover:bg-[#D4A437]"
      >
        Compare Now →
      </Link>
      <button onClick={clear} data-testid="compare-clear-btn" className="text-xs text-slate-500 hover:text-[#D4A437] ml-1">
        Clear
      </button>
    </div>
  );
}
